import { faBasketball } from '@fortawesome/pro-solid-svg-icons';

import { FontAwesomeIcon, FontAwesomeIconProps } from 'atoms/icons';

type Props = {
  className?: string;
  size?: number | FontAwesomeIconProps['size'];
  title?: string;
  color?: string;
};

export const NBABall = ({ className, size = '2x', title, color }: Props) => {
  const fontAwesomeSize = typeof size === 'string' ? size : undefined;
  return (
    <FontAwesomeIcon
      icon={faBasketball}
      className={className}
      size={fontAwesomeSize}
      title={title}
      color={color}
    />
  );
};
